import { FC } from "react";
import { observer } from "mobx-react";

import CoreCard from "../../../ui/core/CoreCard";
import { useObservabilityStore } from "../../../../hooks/useObservabilityStore";
import {
  formatCurrency,
  MetricGrid,
  SectionLabel,
  type Metric,
} from "./MetricTiles";

// Top-line summary: total PromptWrx cost, total recovered revenue, and the net
// value the tenant gets (recovered − cost). Consumes data already loaded by the
// Impact / Cost cards (financialImpact + usageKpis).
const FinancialSummaryBar: FC = observer(() => {
  const { usageKpis, financialImpact } = useObservabilityStore();

  // total_cost is consistent across kpis and financial-impact (non-billable
  // bills carry a $0 flat fee), so either source works; prefer whichever is
  // loaded.
  const totalCost =
    financialImpact?.total_cost ?? usageKpis?.total_cost ?? 0;
  const recovered = financialImpact?.recovered_revenue ?? 0;
  const netValue = recovered - totalCost;

  const metrics: Metric[] = [
    { label: "Total Cost", value: formatCurrency(totalCost) },
    { label: "Recovered Revenue", value: formatCurrency(recovered) },
    {
      label: "Net Value",
      value: formatCurrency(netValue),
      tone: netValue >= 0 ? "positive" : "negative",
    },
  ];

  return (
    <CoreCard sx={{ p: 1, minHeight: "auto", height: "auto" }}>
      <SectionLabel sx={{ mb: 0.5 }}>Summary</SectionLabel>
      <MetricGrid metrics={metrics} columns={3} />
    </CoreCard>
  );
});

export default FinancialSummaryBar;
